import { SYSTEM_ROLE_CODE } from "@/schemas/user";

export const ALLOWED_ROLES_FOR_ASSIGNMENTS = [
  SYSTEM_ROLE_CODE.REGIONAL_DIRECTOR,
  SYSTEM_ROLE_CODE.REGIONAL_REPRESENTATIVE,
  SYSTEM_ROLE_CODE.STORE_COORDINATOR,
  SYSTEM_ROLE_CODE.SUPERVISOR,
];

export const ALLOWED_ROLES_FOR_DEFAULT_ASSIGNMENTS = [
  SYSTEM_ROLE_CODE.REGIONAL_REPRESENTATIVE,
  SYSTEM_ROLE_CODE.STORE_COORDINATOR,
  SYSTEM_ROLE_CODE.SUPERVISOR,
];
